import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

export default function Comp() {
    const { useLang, useState, useEffect } = useGlobal();
    const { t } = useLang('smarthomepanel');
    let layoutH = 1120;
    layoutH = Math.min(layoutH, 1920);
    const [layoutHeight, setLayoutHeight] = useState((layoutH / 1920) * 1080);

    useEffect(() => {
        layoutH = typeof window !== 'undefined' ? window.innerWidth : 1120;
        layoutH = Math.min(layoutH, 1920);
        setLayoutHeight((layoutH / 1920) * 1080);
    }, []);

    return (
        <div className={`${css.gsapA3} gsapA3`} style={{ height: `${layoutHeight}px` }}>
            <div className="msg-out-box">
                <div className="msg-title">{t('smart_home_panel.four_title')}</div>
                <div className="msg-line1">
                    {t('smart_home_panel.four_subtitle_pc')}
                    <div></div>
                    {t('smart_home_panel.four_subtitle1_pc')}
                </div>
            </div>
        </div>
    );
}
